<template>
    <div class="tw-py-2">
        <!--
          Podio armado en bucle (antes eran tres bloques escritos a mano, con los
          colores incrustados): cantidad de puestos y colores salen de la config
          del evento. En pantallas angostas el 4.º y el 5.º bajan a una segunda
          fila; en escritorio flanquean al resto.
        -->
        <div class="tw-flex tw-flex-wrap tw-items-center tw-justify-center tw-gap-x-4 tw-gap-y-2 tw-pt-12 lg:tw-gap-x-6">
            <template v-for="place in places">
                <div
                    v-if="place.breaker"
                    :key="place.key"
                    class="tw-order-5 tw-h-0 tw-basis-full lg:tw-hidden"
                />
                <div v-else :key="place.key" :class="place.orderClass">
                    <div
                        :class="place.isFirst ? 'bz-size-f-bg' : 'bz-size-st-bg'"
                        :style="{ backgroundColor: place.color }"
                    >
                        <img v-if="place.isFirst" src="@/assets/win-c.png" class="bz-win-cr"/>
                        <v-avatar color="primary" :class="place.isFirst ? 'bz-size-f' : 'bz-size-st'">
                            <img :src="place.user.profile_photo_url"/>
                        </v-avatar>
                        <!-- Number -->
                        <div
                            class="bz-position"
                            :class="place.isFirst ? 'bz-postion-size-f' : 'bz-postion-size-st'"
                            :style="{ backgroundColor: place.color, color: place.textColor }"
                        >
                            {{ place.index + 1 }}
                        </div>
                    </div>
                    <div class="tw-py-6 tw-flex tw-flex-col tw-items-center">
                        <span class="tw-text-xs tw-font-bold bz-txt-name">{{ place.user.fullName }}</span>
                        <span class="tw-text-xs tw-text-gray-300">{{ place.user.total }} pts.</span>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { placeColors, placeTextColors, podiumSize } from '@/utils/leaderboardPlaces'

// Posición visual de cada puesto (índice 0 = 1.º): 2.º · 1.º · 3.º en la fila
// principal; 4.º y 5.º en una segunda fila en móvil, y a los costados en
// escritorio. Clases literales para que Tailwind las detecte al compilar.
const ORDER_CLASSES = [
    'tw-order-2',
    'tw-order-1',
    'tw-order-3',
    'tw-order-6 lg:tw-order-first',
    'tw-order-7 lg:tw-order-last',
]

export default {
    props: {
        users: {
            type: [Array, Object],
            default: () => ([]),
        },
    },
    computed: {
        ...mapGetters({
            config: 'event/eventRegistryConfig',
        }),
        places() {
            const list = Array.isArray(this.users) ? this.users : []
            const colors = placeColors(this.config)
            const textColors = placeTextColors(this.config)
            const size = Math.min(podiumSize(this.config), list.length)

            const places = []
            for (let index = 0; index < size; index++) {
                places.push({
                    key: `puesto-${index}`,
                    index,
                    isFirst: index === 0,
                    user: list[index],
                    color: colors[index],
                    textColor: textColors[index],
                    orderClass: ORDER_CLASSES[index],
                })
            }
            if (size > 3) {
                places.push({ key: 'salto-de-fila', breaker: true })
            }
            return places
        },
    },
}
</script>

<style>
.bz-txt-name {
    width: 100px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    text-align: center;
}
.bz-size-f-bg {
    width: 110px !important;
    height: 110px !important;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 100%;
    position: relative;
}

.bz-size-f {
    width: 100px !important;
    height: 100px !important;
}

.bz-size-st-bg {
    width: 80px !important;
    height: 80px !important;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 100%;
    position: relative;
    margin: auto;
}

.bz-size-st {
    width: 70px !important;
    height: 70px !important;
}

.bz-position {
    position: absolute;
    border-radius: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 4px solid #ffffff;
    color: #ffffff;
    font-weight: bold;
}

.bz-postion-size-st {
    width: 25px;
    height: 25px;
    bottom: -10px;
    font-size: 10px;
}

.bz-postion-size-f {
    width: 35px;
    height: 35px;
    bottom: -15px;
    font-size: 14px;
}

.bz-win-cr {
    position: absolute;
    z-index: 1;
    width: 90px;
    top: -40px;
    right: -10px;
    transform: rotate(16deg);
}
</style>